import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { Col, Form, Label, Row } from 'reactstrap';
import FlashMessages from '../Common/Messages/FlashMessages';
import Footer from '../Footer/Footer';
import Header from '../Headers/Header';
import { setPageTitle } from '../../actions/Page/PageAction';
import { useLocation, useNavigate } from 'react-router';
import { Button } from '../Common';
import PasswordStrength from './PasswordStrength';

export const ResetPasswordConfirm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUserName] = useState('');
  const [code, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const onPasswordChange = (password) => {
    setPassword(password);
  };

  const signIn = () => {
    navigate('/');
  };

  const submitNewPassword = async () => {
    password && isPasswordValid ? await resetPassword() : void 0;
  };

  const resetPassword = async () => {
    try {
      await Auth.forgotPasswordSubmit(username, code, password);
      setIsComplete(true);
    } catch (err) {
      console.error(err);
      setMessage(err.message);
    }
  };

  const hideFlashMessage = () => {
    setMessage('');
  };

  const renderCompleteBlock = () => {
    return (
      <Row>
        <p className="pBottom-15 margin-0">You have successfully changed your account password</p>
        <div className="mBottom-15">
          <button
            type="button"
            className="lsn-primary-button-lg width-100 show"
            onClick={signIn}
            id="button-back-to-login">
            Continue to Analytics
          </button>
        </div>
      </Row>
    );
  };

  const renderActiveForm = () => {
    return (
      <Form className="form-set-new-password">
        <p className="mBottom-15">Please enter a new password</p>
        <Row className="v-middle-align">
          <Label for="username" className="ScalaSansOT" sm={3}>
            New Password
          </Label>
          <Col className="input-left" sm={9}>
            <input
              type="password"
              value={password}
              className="input "
              name="password"
              placeholder="password"
              onChange={(evt) => onPasswordChange(evt.target.value)}
            />
          </Col>
        </Row>
        <PasswordStrength
          newPassword={password}
          dirty={!!password}
          labelProps={{
            sm: 3,
            md: 3,
          }}
          containerProps={{
            sm: 9,
            md: 9,
          }}
          onState={(state) => {
            setIsPasswordValid(state.failedLabels.length === 0);
          }}
        />
        <Button
          isNew
          text="Reset"
          stretch
          onClick={submitNewPassword}
          classNames={['mBottom-15']}
          id="button-set-new-password"
        />
      </Form>
    );
  };

  useEffect(() => {
    Auth.signOut();
    dispatch(setPageTitle('Reset Password Confirmation'));
    const value = queryString.parse(location?.search);
    setUserName(value?.username || '');
    setToken(value?.confirmation_code || '');
    return () => {
      dispatch(setPageTitle());
    };
  }, []);

  return (
    <React.Fragment>
      <Header />
      <main className="main-page" aria-labelledby="app_page_title">
        <div className="mobile_margin fontSm-15">
          <div className="md-title">
            <h1 id="app_page_title" className="heading-h1-50">
              {isComplete ? 'Success!' : 'Reset Password'}
            </h1>
          </div>
          <FlashMessages
            scope="ResetPasswordConfirm"
            close={hideFlashMessage}
            type="error"
            msg={message}
            open={!!message}
          />
          <div className="rounded-panel pSm-30">
            {isComplete ? renderCompleteBlock() : renderActiveForm()}
            <Row>
              <Col xs={12}>
                If you have questions at any point, please visit the{' '}
                <span className="anchorParent">
                  <a
                    className="anchor"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://help.liaisonedu.com/Analytics">
                    Help Center
                  </a>
                </span>{' '}
                for FAQs and General Instructions.
              </Col>
            </Row>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default ResetPasswordConfirm;
